export default __webpack_public_path__ + "static/media/banner.0c6031a1.jpg";